// extracted by mini-css-extract-plugin
export default {"ad":"advertiseManage_ad__yiNAj","title":"advertiseManage_title__BsW1J"};